// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__IF61i","bigColWidth":"Table_bigColWidth__127nQ","biggerColWidth":"Table_biggerColWidth__rz_Ul","row":"Table_row__bhARr","col":"Table_col__2NDxO"};